import { Button } from "@altimateai/lego";
import { useGlobalPlaygroundActions } from "@/modules/playground";
import { QueriesTracking } from "@/lib/tracking/queries";

const QueryInsightsChatbot = ({
  queryId,
  instanceId: _instanceId,
}: {
  queryId: string;
  instanceId?: string;
}) => {
  const { openPlayground } = useGlobalPlaygroundActions();

  const handleClick = () => {
    QueriesTracking.chatbotOpened(queryId);
    openPlayground({
      chatbotProps: { initialMessage: "Analyse the query" },
    });
  };

  return (
    <Button variant="secondary" onClick={handleClick}>
      Analyse the query
    </Button>
  );
};

export default QueryInsightsChatbot;
